import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Global 401 handler — turns the raw "Not authenticated" into a clear
// "session expired, please log back in" message with a re-login button.
let sessionToastShown = false;
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Let the initial auth probe / logout fail silently (handled by AuthContext).
    const isSilent = url.includes("/auth/me") || url.includes("/auth/logout") || url.includes("/auth/heartbeat");
    if (status === 401 && !isSilent && !sessionToastShown) {
      sessionToastShown = true;
      const isAdmin = window.location.pathname.startsWith("/admin");
      const loginPath = isAdmin ? "/admin" : "/login";
      toast.error("Session expirée — vous avez été déconnecté", {
        description: "Reconnectez-vous pour continuer. Votre action n'a pas été enregistrée.",
        duration: 12000,
        action: {
          label: "Se reconnecter",
          onClick: () => { window.location.href = loginPath; },
        },
        onDismiss: () => { sessionToastShown = false; },
        onAutoClose: () => { sessionToastShown = false; },
      });
    }
    // Normalise the raw backend detail so any local catch shows a friendly FR message
    // instead of "Not authenticated" / "Session expired".
    if (status === 401 && !isSilent && error?.response?.data) {
      error.response.data.detail = "Session expirée — reconnectez-vous";
    }
    return Promise.reject(error);
  }
);

export const SERVICE_GROUPS = ["Performance", "Émissions", "Diagnostic", "Sécurité"];
